/**
 * @file   src\components\RadioButton.tsx
 * @brief  Input with label component.
 * @date   July, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import {React} from '../utils/thirdpartyComponents'

import { RadioButtonProperty } from "src/interfaces/generalInterface"

const RadioButton = ({ name, value, onChange, description , label, checked, disabled}: RadioButtonProperty) => {
    return (

        <label className="radio-wrap">
            <input
                name={name}
                type="radio"
                value={value}
                onChange={(event) => onChange && onChange(event)}
                checked= {checked}
                disabled = {disabled}
            />
            <span>
                <div className="text-info">
                    <h6>{label ? label : name}</h6>
                   {description && <p>{description}</p> }
                </div>
            </span>
        </label>

    )
}

export default RadioButton